import classes from "./index.module.scss";
import Container from "../Container";
import btnClasses from "../../../components/commons/Button.module.scss";
import png from "../images/iso.png";
import webp from "../images/iso.webp";

export default function ISO() {
  return (
    <section>
      <Container>
        <div className={classes.body}>
          <div className={classes.image}>
            <picture>
              <source srcSet={webp} type="image/webp" />
              <img src={png} alt="ISO" width={253} height={154} />
            </picture>
          </div>
          <h2 className={classes.title}>ISO certification</h2>
          <p className={classes.text}>
            Our products comply with international ISO certification. That means
            we guarantee product compliance with safety requirements and
            generally accepted regulations. Top-notch quality is one of our
            utmost priorities
          </p>
          <a
            data-content="download"
            className={`${btnClasses.button} ${classes.button}`}
            href="/pdf/iso-sertificat.pdf"
            download
          >
            download
          </a>
        </div>
      </Container>
    </section>
  );
}
